import React from 'react';
import styles from './PreviewArea.less';

const PreviewArea = ({ data }) => {
  const { title, subTitle, promotionModuleList = [] } = data;

  const renderNormalLayout = (tabList) => {
    return (
      <div className={styles.normalGrid}>
        {tabList.map((item, index) => (
          <div key={index} className={styles.normalItem}>
            <div className={styles.itemIconWrapper}>
              {item.tabIcon ? (
                <img src={item.tabIcon} alt="icon" />
              ) : (
                <div className={styles.placeholderIcon} />
              )}
            </div>
            <div className={styles.itemName}>{item.tabName}</div>
          </div>
        ))}
      </div>
    );
  };

  const renderSpecialLayout = (tabList) => {
    // 1, 2, 3 on the left; 4 on the right
    const item1 = tabList[0];
    const item2 = tabList[1];
    const item3 = tabList[2];
    const item4 = tabList[3];

    return (
      <div className={styles.specialGrid}>
        <div className={styles.specialLeft}>
          <div className={styles.specialLeftTop}>
            {item1 && (
              <div className={styles.specialSmallItem}>
                <div className={styles.itemIconWrapper}>
                  {item1.tabIcon ? (
                    <img src={item1.tabIcon} alt="icon" />
                  ) : (
                    <div className={styles.placeholderIcon} />
                  )}
                </div>
                <div className={styles.itemName}>{item1.tabName}</div>
              </div>
            )}
            {item2 && (
              <div className={styles.specialSmallItem}>
                <div className={styles.itemIconWrapper}>
                  {item2.tabIcon ? (
                    <img src={item2.tabIcon} alt="icon" />
                  ) : (
                    <div className={styles.placeholderIcon} />
                  )}
                </div>
                <div className={styles.itemName}>{item2.tabName}</div>
              </div>
            )}
          </div>
          {item3 && (
            <div className={styles.specialWideItem}>
              <div className={styles.itemIconWrapper}>
                {item3.tabIcon ? (
                  <img src={item3.tabIcon} alt="icon" />
                ) : (
                  <div className={styles.placeholderIcon} />
                )}
              </div>
              <div className={styles.itemName}>{item3.tabName}</div>
            </div>
          )}
        </div>
        {item4 && (
          <div className={styles.specialRight}>
            <div className={styles.specialLargeItem}>
              <div className={styles.largeIconWrapper}>
                {item4.tabIcon ? (
                  <img src={item4.tabIcon} alt="icon" />
                ) : (
                  <div className={styles.placeholderLargeIcon}>+</div>
                )}
              </div>
              <div className={styles.itemName}>{item4.tabName}</div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={styles.phoneShell}>
      <div className={styles.phoneNotch}></div>
      <div className={styles.previewContainer}>
        <div className={styles.header}>
          <div className={styles.title}>{title || '标题'}</div>
          <div className={styles.subTitle}>{subTitle || '副标题'}</div>
        </div>

        <div className={styles.moduleList}>
          {promotionModuleList.map((module, index) => (
            <div key={index} className={styles.moduleGroup}>
              <div className={styles.groupHeader}>
                <span className={styles.groupTitle}>{module.moduleName}</span>
                {module.upperRightTab && module.upperRightTab.tabName && (
                  <span className={styles.groupMore}>
                    {module.upperRightTab.tabName} &gt;
                  </span>
                )}
              </div>

              {module.styleType === 1
                ? renderSpecialLayout(module.moduleTabList || [])
                : renderNormalLayout(module.moduleTabList || [])}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviewArea;
